import React from 'react';
import Modal from 'react-modal';

const customStyles = {
  content: {
    background: 'none',
    padding: 0,
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    inset: 0,
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.85)',
    zIndex: 2003,
  },
};

const LightboxSimple = ({ isOpen, onClose, imageUrl, altText = '' }) => {
  if (!imageUrl) return null;

  return (
    <Modal
      ariaHideApp={false}
      preventScroll={true}
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      shouldCloseOnOverlayClick={true}
    >
        <div className="lightbox-simple__container">
            <button
                type="button"
                onClick={onClose}
                className="lightbox-simple__close-btn"
                aria-label="Stäng"
            >
            &times;
            </button>
            <img
                src={imageUrl}
                alt={altText}
            />
        </div>
    </Modal>
  );
};

export default LightboxSimple;